<template>
  <b-container
    class="bv-example-row bv-example-row-flex-cols table-wrapper"
    fluid
  >
    <!--    <b-row align-v="center" class="filter-wrapper">-->
    <!--      <b-col>-->
    <!--        <invoice-filter-component-->
    <!--          :filter-type.sync="filterType"-->
    <!--          :direction-filter-selected.sync="directionFilterSelected"-->
    <!--          :corporation-filter-selected.sync="corporationFilterSelected"-->
    <!--          :status-filter-selected.sync="statusFilter"-->
    <!--          :platforms-type.sync="platformsTypeFilter"-->
    <!--        />-->
    <!--      </b-col>-->
    <!--    </b-row>-->
    <b-row>
      <b-table
        striped
        hover
        small
        outlined
        bordered
        foot-clone
        show-empty
        :current-page="currentPage"
        :per-page="perPage"
        :fields="fields"
        :items="itemsFilterComputed"
      >
        <template slot="no" slot-scope="data">
          <div class="col-right">
            {{
              $numeral(perPage * (currentPage - 1) + data.index + 1).format(
                "0,0[.]00"
              )
            }}
          </div>
        </template>
        <template slot="hospital_name" slot-scope="data">
          <div class="col-left">
            {{ data.item.hospital_name || data.item.custom_hospital }}
          </div>
        </template>
        <template slot="direction" slot-scope="data">
          <div class="col-left">{{ data.item.direction }}</div>
        </template>
        <template slot="invoice" slot-scope="data">
          <div class="col-right">{{ data.item.invoice }}</div>
        </template>
        <template slot="amount" slot-scope="data">
          <div class="col-right">
            {{ $numeral(data.item.amount).format("0,0[.]00") }}
          </div>
        </template>
        <template slot="FOOT_no">
          <div class="col-right" />
        </template>
        <template slot="FOOT_hospital_name">
          <div class="col-left" />
        </template>
        <template slot="FOOT_direction">
          <div class="col-left" />
        </template>
        <template slot="FOOT_invoice">
          <div class="col-right">รวม</div>
        </template>
        <template slot="FOOT_amount">
          <div class="col-right" v-if="itemsFilterComputed">
            {{
              $numeral(
                itemsFilterComputed
                  .reduce((a, b) => a + +b.amount, 0)
                  .toFixed(2)
              ).format("0,0[.]00")
            }}
          </div>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col cols="auto">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import InvoiceFilterComponent from "./invoiceFilterComponent";
import * as moment from "moment";
import { mapActions } from "vuex";

export default {
  name: "InvoiceTable",
  components: {
    InvoiceFilterComponent,
  },
  props: {
    reportType: {
      type: String,
      required: true,
    },
    itemsFilter: {
      required: true,
    },
    itemsObject: {
      required: true,
    },
    dateType: {
      type: String,
      required: true,
    },
    fromDate: {
      type: Date,
      required: true,
    },
    toDate: {
      type: Date,
      required: true,
    },
    statusFilter: {
      required: true,
    },
    directionFilterSelected: {
      required: true,
    },
    filterType: {
      required: true,
    },
    corporationFilterSelected: {
      required: true,
    },
    platformsTypeFilter: {
      required: true,
    },
    creditTypeSelected: {
      required: true,
    },
  },
  data() {
    return {
      // filterType: "all",
      // directionFilterSelected: null,
      // corporationFilterSelected: null,
      // platformsTypeFilter: "corporation",
      // statusFilter: null,
      currentPage: 1,
      perPage: 50,
      fields: [
        {
          key: "no",
          label: "ลำดับ",
        },
        {
          key: "hospital_name",
          label: "สถานที่",
        },
        {
          key: "direction",
          label: "เขต",
        },
        {
          key: "invoice",
          label: "Invoice",
        },
        {
          key: "amount",
          label: "จำนวน",
        },
      ],
    };
  },
  computed: {
    itemsFilterComputed: {
      get() {
        return this.itemsFilter;
      },
      set(value) {
        this.$emit("update:itemsFilter", value);
      },
    },
    totalRows() {
      return this.itemsFilterComputed.length;
    },
  },
  watch: {
    // dateType() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // },
    // fromDate() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // },
    // toDate() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // },
    // filterType() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // },
    // directionFilterSelected() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // },
    // corporationFilterSelected() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // },
    // statusFilter() {
    //   if (this.reportType === "invoiceReport") {
    //     this.filters();
    //   }
    // }
  },
  created() {
    this.setCorporations();
  },
  methods: {
    ...mapActions({
      filter: "Account/reportInvoiceFilter",
      setCorporations: "Corporation/setAll",
    }),
    async filters() {
      // check input informed ?
      this.$store.state.isLoading = true;
      let firstDate = moment(this.fromDate);
      let lastDate = moment(this.toDate);

      if (this.dateType === "date") {
        firstDate = firstDate.startOf("days");
        lastDate = lastDate.endOf("days");
      } else if (this.dateType === "month") {
        firstDate = firstDate.startOf("months");
        lastDate = lastDate.endOf("months");
      } else if (this.dateType === "year") {
        firstDate = firstDate.startOf("years");
        lastDate = lastDate.endOf("years");
      }
      firstDate = firstDate.unix();
      lastDate = lastDate.unix();
      // let lastDate;
      // if (this.dateType === 'date') {
      //   lastDate = moment(this.toDate).unix() * 1000
      //   } else {
      //     lastDate = new Date(
      //     this.toDate.getFullYear(),
      //     this.toDate.getMonth() + 1,
      //     0
      //   );
      // }

      let result = await this.filter({
        filter_type: this.filterType,
        direction_filter_selected: this.directionFilterSelected || "",
        corporation_filter_selected: this.corporationFilterSelected || "",
        status_filter: this.statusFilter || "",
        date_type: this.dateType,
        from_date: firstDate,
        to_date: lastDate,
        platform_type: this.platformsTypeFilter,
        credit_type_selected: this.creditTypeSelected,
      });

      if (result.success) {
        this.itemsFilterComputed = result.result;
        this.$emit("update:itemsObject", result);
        this.$store.state.isLoading = false;
      } else {
        this.$bvToast.toast(`${result.errors}`, {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          variant: "danger",
        });
        this.$store.state.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  background: #eaeced;
  padding: 1rem;
}

.table-wrapper {
  padding: 2rem;
}
</style>
